import { getAppInstance as publicGetAppInstance } from './devcenter-app-instance-v1-app-instance-app-instances.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onAppInstanceInstalled as publicOnAppInstanceInstalled } from './devcenter-app-instance-v1-app-instance-app-instances.public.js';
import { onAppInstanceRemoved as publicOnAppInstanceRemoved } from './devcenter-app-instance-v1-app-instance-app-instances.public.js';
import { onAppInstancePaidPlanAutoRenewalCancelled as publicOnAppInstancePaidPlanAutoRenewalCancelled } from './devcenter-app-instance-v1-app-instance-app-instances.public.js';
import { onAppInstancePaidPlanChanged as publicOnAppInstancePaidPlanChanged } from './devcenter-app-instance-v1-app-instance-app-instances.public.js';
import { onAppInstancePaidPlanPurchased as publicOnAppInstancePaidPlanPurchased } from './devcenter-app-instance-v1-app-instance-app-instances.public.js';
import { onAppInstancePlanConvertedToPaid as publicOnAppInstancePlanConvertedToPaid } from './devcenter-app-instance-v1-app-instance-app-instances.public.js';
import { onAppInstancePlanReactivated as publicOnAppInstancePlanReactivated } from './devcenter-app-instance-v1-app-instance-app-instances.public.js';
import { onAppInstancePlanTransferred as publicOnAppInstancePlanTransferred } from './devcenter-app-instance-v1-app-instance-app-instances.public.js';

export const getAppInstance: MaybeContext<
  BuildRESTFunction<typeof publicGetAppInstance> & typeof publicGetAppInstance
> = /*#__PURE__*/ createRESTModule(publicGetAppInstance);
/**
 * Triggered when an instance of your app is installed on a Wix site.
 */
export const onAppInstanceInstalled: BuildEventDefinition<
  typeof publicOnAppInstanceInstalled
> &
  typeof publicOnAppInstanceInstalled = createEventModule(
  publicOnAppInstanceInstalled
);
/**
 * Triggered when an instance of your app is uninstalled from a Wix site.
 */
export const onAppInstanceRemoved: BuildEventDefinition<
  typeof publicOnAppInstanceRemoved
> &
  typeof publicOnAppInstanceRemoved = createEventModule(
  publicOnAppInstanceRemoved
);
/**
 * Triggered when a Wix user either cancels a paid plan for your app, or cancels the plan's auto-renewal. The
 * Wix user can continue to use your app until the end of the current billing
 * cycle.
 */
export const onAppInstancePaidPlanAutoRenewalCancelled: BuildEventDefinition<
  typeof publicOnAppInstancePaidPlanAutoRenewalCancelled
> &
  typeof publicOnAppInstancePaidPlanAutoRenewalCancelled = createEventModule(
  publicOnAppInstancePaidPlanAutoRenewalCancelled
);
/**
 * Triggered when a Wix user upgrades or downgrades their plan for your app.
 */
export const onAppInstancePaidPlanChanged: BuildEventDefinition<
  typeof publicOnAppInstancePaidPlanChanged
> &
  typeof publicOnAppInstancePaidPlanChanged = createEventModule(
  publicOnAppInstancePaidPlanChanged
);
/**
 * Triggered when a Wix user purchases a paid plan for your app.
 */
export const onAppInstancePaidPlanPurchased: BuildEventDefinition<
  typeof publicOnAppInstancePaidPlanPurchased
> &
  typeof publicOnAppInstancePaidPlanPurchased = createEventModule(
  publicOnAppInstancePaidPlanPurchased
);
/**
 * Triggered when a Wix user reaches the end of a free-trial period and is charged successfully.
 */
export const onAppInstancePlanConvertedToPaid: BuildEventDefinition<
  typeof publicOnAppInstancePlanConvertedToPaid
> &
  typeof publicOnAppInstancePlanConvertedToPaid = createEventModule(
  publicOnAppInstancePlanConvertedToPaid
);
/**
 * Triggered when auto-renewal is turned on for a paid plan.
 */
export const onAppInstancePlanReactivated: BuildEventDefinition<
  typeof publicOnAppInstancePlanReactivated
> &
  typeof publicOnAppInstancePlanReactivated = createEventModule(
  publicOnAppInstancePlanReactivated
);
/**
 * Triggered when a paid plan for your app is transferred to a different Wix account.
 */
export const onAppInstancePlanTransferred: BuildEventDefinition<
  typeof publicOnAppInstancePlanTransferred
> &
  typeof publicOnAppInstancePlanTransferred = createEventModule(
  publicOnAppInstancePlanTransferred
);

export {
  PaymentCycle,
  FreeTrialStatus,
  FreeTrialPeriod,
  ReactivationReason,
  ResolutionMethod,
  WebhookIdentityType,
} from './devcenter-app-instance-v1-app-instance-app-instances.universal.js';
export {
  AppInstance,
  BillingInfo,
  FreeTrialInfo,
  AvailablePlan,
  AppInstalled,
  AppRemoved,
  PaidPlanPurchased,
  PaidPlanChanged,
  PaidPlanAutoRenewalCancelled,
  PlanTransferred,
  PlanReactivated,
  PlanConvertedToPaid,
  GetAppInstanceRequest,
  GetAppInstanceResponse,
  SiteInfo,
  Multilingual,
  SupportedLanguage,
  Locale,
  OwnerInfo,
  GetAppInstanceByInstanceIdRequest,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  AppInstanceInstalledEnvelope,
  AppInstanceRemovedEnvelope,
  AppInstancePaidPlanAutoRenewalCancelledEnvelope,
  AppInstancePaidPlanChangedEnvelope,
  AppInstancePaidPlanPurchasedEnvelope,
  AppInstancePlanConvertedToPaidEnvelope,
  AppInstancePlanReactivatedEnvelope,
  AppInstancePlanTransferredEnvelope,
} from './devcenter-app-instance-v1-app-instance-app-instances.universal.js';
export {
  PaymentCycleWithLiterals,
  FreeTrialStatusWithLiterals,
  FreeTrialPeriodWithLiterals,
  ReactivationReasonWithLiterals,
  ResolutionMethodWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './devcenter-app-instance-v1-app-instance-app-instances.universal.js';
